// extracted by mini-css-extract-plugin
module.exports = {"externalLink":"HeaderExternalLinks_externalLink__GU36f","socialLinks":"HeaderExternalLinks_socialLinks__RdgKL","socialLink":"HeaderExternalLinks_socialLink__29h5Z"};